/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UnlockedContentInterface } from '../../+models';
import { UpdateUnlockedContentResultInterface } from '../../bundle';
import { ModelApiBase, PolpoApi } from '../shared';
@Injectable({ providedIn: 'root' })
export class UnlockedContentApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'UnlockedContents');
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete(path).pipe(map(() => true));
  }

  createUnlockedContents(
    unlockedContents: Partial<UnlockedContentInterface>[]
  ): Observable<UpdateUnlockedContentResultInterface> {
    const path = 'create-unlocked-contents';
    return this.post<UpdateUnlockedContentResultInterface>(path, undefined, { unlockedContents });
  }

  updateUnlockedContents(
    update: Partial<UnlockedContentInterface>[]
  ): Observable<UpdateUnlockedContentResultInterface> {
    const path = 'update-unlocked-contents';
    return this.patch<UpdateUnlockedContentResultInterface>(path, undefined, update);
  }
}
